import React from 'react';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';
import i18next from "i18next";

const ConfirmDialogEx = ({ show, proceed, dismiss, cancel, confirmation, options }) => {
    if (!show) return null;

    // Новый флаг: если options.safeCancel === true, крестик вызывает cancel()
    const handleCloseClick = (...args) => {
        if (options && options.safeCancel && typeof cancel === "function") {
            cancel(...args);       // новая логика (крестик = отмена)
        } else if (typeof dismiss === "function") {
            dismiss(...args);      // старая логика (просто закрыть)
        }
    };

    return (
        <div className="modal fade show" id="myModal" style={{ display: "block" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">
                            {options.header ? options.header : i18next.t('Confirm')}
                        </h4>
                        {/* крестик */}
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            onClick={handleCloseClick}
                        >
                            &times;
                        </button>
                    </div>

                    <div className="modal-body">{confirmation}</div>

                    <div className={`modal-footer text-right ${options.footerClass || ""}`}>
                        <button
                            type="button"
                            className={`btn btn-regular ${options.confirmBtnClass || ''}`}
                            data-dismiss="modal"
                            onClick={proceed}
                        >
                            {!!options.confirmBtnText ? options.confirmBtnText : "OK"}
                        </button>

                        {!options.hideCancelButton && (
                            <button
                                type="button"
                                className={`btn btn-regular ${options.cancelBtnClass || ''}`}
                                data-dismiss="modal"
                                onClick={cancel}
                            >
                                {!!options.cancelBtnText
                                    ? options.cancelBtnText
                                    : i18next.t('Cancel')}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

ConfirmDialogEx.propTypes = {
    show: PropTypes.bool,
    proceed: PropTypes.func,
    cancel: PropTypes.func,
    dismiss: PropTypes.func,
    confirmation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    options: PropTypes.object,
};

export default confirmable(ConfirmDialogEx);
